import { inject, Injectable } from '@angular/core';
import { IdentityVerificationData } from '../../../../../../../models/order/workflow/credit-check/identity-verification.model';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { CreditCheckStateService } from '../credit-check-state.service';

@Injectable({ providedIn: 'root' })
export class IdentityVerificationStateService extends BaseWorkflowStateService<IdentityVerificationData> {
    private creditCheckStateService = inject(CreditCheckStateService);
    protected override stateKey: string = 'identityVerification';

    protected override saveLocalDraft(): void {
        this.creditCheckStateService.updateData({ identityVerification: this.state() });
    }
}